/* eslint-disable no-use-before-define */
import React from 'react'

export const NO_RESULT_ICON_HTML = `
    <svg width="40" height="33" viewBox="0 0 40 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.319946 0.120117V25.0801H7.51995V32.9521L15.3919 25.0801H39.6799V0.120117H0.319946ZM38.7199 24.1201H15.0079L8.47995 30.6481V24.1201H1.27995V1.08012H38.7199V24.1201ZM20.4799 16.1041L20.5759 5.01612H19.4239L19.5199 16.1041H20.4799ZM19.9999 20.3761C20.5279 20.3761 20.9599 19.9921 21.0079 19.4641C21.0559 18.9361 20.6239 18.5041 20.0959 18.4561C19.5679 18.4081 19.1359 18.8401 19.0879 19.3681C19.0879 19.3681 19.0879 19.3681 19.0879 19.4161C19.0879 19.9441 19.4719 20.3281 19.9999 20.3761Z" fill="#242424"/>
    </svg>`


export const NO_RESULT_ICON =
    <svg width="40" height="33" viewBox="0 0 40 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.319946 0.120117V25.0801H7.51995V32.9521L15.3919 25.0801H39.6799V0.120117H0.319946ZM38.7199 24.1201H15.0079L8.47995 30.6481V24.1201H1.27995V1.08012H38.7199V24.1201ZM20.4799 16.1041L20.5759 5.01612H19.4239L19.5199 16.1041H20.4799ZM19.9999 20.3761C20.5279 20.3761 20.9599 19.9921 21.0079 19.4641C21.0559 18.9361 20.6239 18.5041 20.0959 18.4561C19.5679 18.4081 19.1359 18.8401 19.0879 19.3681C19.0879 19.3681 19.0879 19.3681 19.0879 19.4161C19.0879 19.9441 19.4719 20.3281 19.9999 20.3761Z" fill="#242424"/>
    </svg>



// WEBPACK FOOTER //
// ./src/twd/icons/no-result.js